<template>
  <div class="form-item-type">
    <a-form-model-item
      :label="label"
      v-if="item"
      :extra="extraText"
      :prop="propName"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      style="width: 100%;"
    >
      <!-- 整数型 -->
      <a-input-number
        v-model="value"
        v-if="item.dataType === 1"
        style="width:100%;"
        :placeholder="$t('com_form_input_placeholder')"
        :disabled="disabled"
      />

      <!-- 浮点型 -->
      <a-input-number
        v-model="value"
        v-if="item.dataType === 2"
        :formatter="
          value => {
            return formatter(`${value}`, this.decimal);
          }
        "
        :step="1 / Math.pow(10, this.decimal)"
        style="width:100%;"
        :placeholder="$t('com_form_input_placeholder')"
        :disabled="disabled"
      >
        <slot></slot>
      </a-input-number>

      <!-- 字符串型 -->
      <a-input
        type="text"
        v-model="value"
        v-if="item.dataType === 3"
        :maxLength="max"
        :placeholder="$t('com_form_input_placeholder')"
        :disabled="disabled"
      />

      <!-- 枚举型 -->
      <a-select
        v-model="value"
        v-if="item.dataType === 4"
        style="min-width: 120px"
        :dropdownMatchSelectWidth="false"
        :placeholder="$t('com_form_select_placeholder')"
        :disabled="disabled"
      >
        <a-select-option v-for="opts in options" :key="opts.value" :value="opts.value">
          {{ opts.name }}
        </a-select-option>
      </a-select>
    </a-form-model-item>
    <div class="form-item-unit" v-if="item.dataUnit">
      {{ item.dataUnit }}
    </div>
  </div>
</template>
<script>
import { trim } from '@/libs/utils';

export default {
  props: ['record', 'propName', 'item', 'itemValue', 'label', 'disabled', 'labelCol', 'wrapperCol'],
  data() {
    return {
      min: 0,
      max: 100000000,
      decimal: 2,
      extraText: '',
      options: [],

      value: undefined,
    };
  },
  watch: {
    itemValue(value) {
      this.value = value;
    },
    value(val) {
      // 更新.sync对应的form数据
      this.$emit('update:itemValue', val, this.record);
    },
  },
  created() {
    this.value = this.itemValue;
    this.formatItem(this.item);
  },
  methods: {
    /**
     * 指定保留的位数
     */
    formatter(value, num) {
      const newValue = value.split('.');
      if (newValue.length > 2) {
        newValue.pop();
      }
      if (newValue[1] && newValue[1].length > num) {
        newValue[1] = newValue[1].slice(0, num);
      }
      return newValue.join('.');
    },

    // 格式化数据
    formatItem(value) {
      let text = '';
      if (trim(value)) {
        if (value.dataType === 1) {
          // 整数
          if (value.dataRange && typeof value.dataRange === 'string') {
            const arr = value.dataRange.split('~');
            if (arr && arr.length === 2) {
              this.min = Number(arr[0]) || 0;
              this.max = Number(arr[1]) || 100000000;
              // text = `Only integer number, min: ${this.min}, max: ${this.max}`;
              text = this.$t('com_form_validate_type_integer_min_max', {
                min: this.min,
                max: this.max,
              });
            }
          }
          text = text ? text : this.$t('com_form_validate_type_integer');
        } else if (value.dataType === 2) {
          // 浮点数
          if (value.dataRange && typeof value.dataRange === 'string') {
            const arr = value.dataRange.split('|');
            if (arr && arr.length === 2) {
              this.decimal = arr[1];
              const arr2 = arr[0].split('~');
              if (arr2 && arr2.length === 2) {
                this.min = Number(arr2[0]) || 0;
                this.max = Number(arr2[1]) || 10000000;
                // text = `Only floating number , min: ${this.min}, max: ${this.max}, decimal: ${this.decimal}`;
                text = this.$t('com_form_validate_type_float_min_max', {
                  min: this.min,
                  max: this.max,
                  decimal: this.decimal,
                });
              }
            }
          }
          text = text ? text : this.$t('com_form_validate_type_float');
        } else if (value.dataType === 3) {
          // 字符串
          if (value.dataRange && typeof value.dataRange === 'string') {
            const arr = value.dataRange.split('~');
            if (arr && arr.length === 2) {
              this.min = Number(arr[0]) || 0;
              this.max = Number(arr[1]) || 10000000;
              // text = `Only string , min length: ${arr[0]}, max length: ${arr[1]}`;
              text = this.$t('com_form_validate_type_string_min_max', {
                min: arr[0],
                max: arr[1],
              });
            }
          }
          text = text ? text : this.$t('com_form_validate_type_string');
        } else if (value.dataType === 4) {
          // 枚举型
          if (value.dataRange && typeof value.dataRange === 'string') {
            const arr = value.dataRange.split('\n');
            if (arr && arr.length) {
              arr.forEach(item => {
                const _temp = item.split('|');
                if (_temp && _temp.length >= 2) {
                  const name = trim(_temp[0]);
                  let value = trim(_temp[1]);
                  const valueType = trim(_temp[2]);

                  // 类型处理
                  if (valueType === 'number') {
                    value = Number(value);
                  } else if (valueType === 'boolean') {
                    value = Boolean(value);
                  }

                  this.options.push({
                    name,
                    value,
                  });
                }
              });
            }
          }
        }
      }
      this.extraText = text;
    },
  },
};
</script>
<style lang="less" scoped>
.form-item-type {
  display: flex;
  align-items: flex-start;
  width: 100%;

  .form-item-unit {
    font-size: 12px;
    color: #40a9ff;
    margin-left: 5px;
    // width: 80px;
    padding-right: 10px;
    padding-top: 11px;
    white-space: nowrap;
  }
}
.form-item-extra {
  font-size: 12px;
  color: #999;

  &.form-item-extra-label {
    padding-left: 20px;
  }
}
</style>
